'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './project-edit.routes';

export class ProjectEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, ProjectService, SettingsService, $uibModal, User) {
    'ngInject';

    this.projectId = $stateParams.id;

    this.dialogs = dialogs;
    this.ProjectService = ProjectService;
    this.SettingsService = SettingsService;
    this.$uibModal = $uibModal;
    this.User = User;
    this.Auth = Auth;

    this.jsonValue = "";
    this.users = [];
    this.$state = $state;

    this.model = {
    };

    SettingsService.getByName({name: 'project-board-presets'}, setting => {
      this.presets = setting.data;
    });

    if (this.projectId) {
      this.ProjectService.get({id: this.projectId}, data => {
        this.model = data;

        if (this.model.startDate)
          this.model.startDate = new Date(this.model.startDate);

        if (this.model.targetDate)
          this.model.targetDate = new Date(this.model.targetDate);

        if (this.model.projectLead)
          this.model.projectLead = this.model.projectLead._id;

      }, err => {
        console.log('Could not load vendor from server');
      })
    }

    this.User.query(data => {
      this.users = data.map(user => {
        return {
          value: user._id,
          name: user.shortName || (user.firstName + ' ' + user.lastName)
        };
      });
    });
  }

  setColumns() {
    let name = this.selectedPreset;

    let idx = this.presets.findIndex(preset => {return preset.name == name});

    if (idx !== -1) {
      this.selectedPresetDescription = this.presets[idx].description;
      this.model.columns = this.presets[idx].columns;
    }
  }

  openStartDatePopup() {
    this.startDatePopupOpened = true;
  }

  openTargetDatePopup() {
    this.targetDatePopupOpened = true;
  }


  userLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.model.projectLead = user._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.projectId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The project has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("project-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.projectId) {  // Save changes on the current settings
        this.ProjectService.update({id: this.projectId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.ProjectService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.projectEdit', [uiRouter])
  .config(routes)
  .component('projectEdit', {
    template: require('./project-edit.html'),
    controller: ProjectEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/project/edit/project-edit.component.js